import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't send reset email");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="max-w-md mx-auto px-6 py-20" data-testid="forgot-success">
        <div className="brutal-card p-10">
          <Mail className="text-[#C62828]" size={48} strokeWidth={1.5}/>
          <div className="label-tag mt-4">Check Your Inbox</div>
          <h1 className="font-heading text-3xl md:text-4xl font-black uppercase mt-2 leading-none text-[#1A365D]">
            Reset link sent.
          </h1>
          <p className="mt-4 text-slate-700 leading-relaxed">
            If an account with <strong>{email}</strong> exists, we just emailed a reset link. It expires in 1 hour. Check your spam folder if it doesn't arrive in a few minutes.
          </p>
          <Link to="/login" className="btn-secondary mt-8 inline-flex items-center gap-2" data-testid="back-to-login-link">
            <ArrowLeft size={16}/> Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="forgot-password-page">
      <div className="label-tag">Account Recovery</div>
      <h1 className="font-heading text-4xl md:text-5xl font-black uppercase mt-2 leading-none text-[#1A365D]">
        Forgot your password?
      </h1>
      <p className="mt-2 text-slate-600">Enter the email on your account and we'll send you a reset link.</p>

      <form onSubmit={submit} className="brutal-card p-8 mt-8 space-y-5">
        <div>
          <label className="label-tag block mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="ll-input" data-testid="forgot-email-input"/>
        </div>
        <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="forgot-submit-btn">
          {loading ? "Sending…" : "Send Reset Link"}
        </button>
        <div className="text-sm text-slate-600 text-center">
          Remembered it? <Link to="/login" className="font-bold text-[#C62828] hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
